// src/components/BrandLogo.tsx
// Real mark + colors from the official brand book (visaguideos_brand_identity.html,
// "01 — Logo System" / "02 — Color Palette · Quantum Blue System"): a custom rocket
// glyph (not the generic Lucide Rocket icon this component used before), on a
// rounded-lg gradient from Electric Blue #3B82F6 to Violet Bloom #A855F7. Wordmark is
// "VISAGUIDEOS" as one word, three-color split (white / Electric Blue / Violet→Pink),
// matching the brand book's horizontal lockup exactly.
import React from 'react';

interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'default' | 'minimal' | 'full';
  className?: string;
}

const RocketMark: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 6C32 6 18 18 18 36C18 42 20.5 47 23.5 50L27 46.5C25.5 44 24 40 24 36C24 28 28.5 18.5 32 14C35.5 18.5 40 28 40 36C40 40 38.5 44 37 46.5L40.5 50C43.5 47 46 42 46 36C46 18 32 6 32 6Z" fill="white" />
    <path d="M22 44L18 58L32 52L46 58L42 44C38.5 47 35.5 48 32 48C28.5 48 25.5 47 22 44Z" fill="white" opacity="0.9" />
    <circle cx="32" cy="30" r="6" fill="white" />
    <path d="M26 36 C26 36 28 39 32 39 C36 39 38 36 38 36" stroke="#0A1025" strokeWidth="1.2" strokeLinecap="round" opacity="0.3" />
  </svg>
);

export const BrandLogo: React.FC<BrandLogoProps> = ({
  size = 'md',
  variant = 'default',
  className = ''
}) => {
  const sizeConfig = {
    sm: { icon: 'h-4 w-4', text: 'text-sm', container: 'h-6 w-6' },
    md: { icon: 'h-6 w-6', text: 'text-xl', container: 'h-10 w-10' },
    lg: { icon: 'h-8 w-8', text: 'text-2xl', container: 'h-12 w-12' },
    xl: { icon: 'h-10 w-10', text: 'text-3xl', container: 'h-14 w-14' }
  };

  const { icon, text, container } = sizeConfig[size];

  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <div className={`flex items-center justify-center rounded-lg bg-gradient-to-br from-[#3B82F6] to-[#A855F7] ${container} shadow-lg`}>
        <RocketMark className={icon} />
      </div>
      {variant !== 'minimal' && (
        <div className="flex flex-col">
          <span className={`font-black tracking-tight ${text}`}>
            <span className="text-white">VISA</span>
            <span className="text-[#3B82F6]">GUIDE</span>
            <span className="bg-gradient-to-r from-[#A855F7] to-[#EC4899] bg-clip-text text-transparent">OS</span>
          </span>
          {variant === 'full' && (
            <span className="text-xs text-white/60 font-medium mt-[-2px]">
              AI Immigration Consultants
            </span>
          )}
        </div>
      )}
    </div>
  );
};
